document.addEventListener("DOMContentLoaded", (event) => {

    const fullPaletteElm = 6;
    const detailsElements = document.querySelectorAll("details");
    const shadeImageWrap = document.getElementById("shade_image_popup_wrap");
    //const shadeImageActionWrap = document.getElementById('shade_image_popup_action');
    //const shadeImageActionContent = document.getElementById('shade_image_popup_content');



    // Add the onclick listeners.
    detailsElements.forEach(detail => {
        detail.addEventListener("toggle", function() {
            if (this.open) {
                let imageUrl = detail.getAttribute("data-image");
                let swatch_id = detail.getAttribute("data-id");
                let imagesUrl = detail.getAttribute("data-images");
                let imageSwatchArray = imagesUrl.split(',');


                _createModalSwatch(imageUrl,swatch_id,imageSwatchArray);

                //shadeImageActionWrap.innerHTML = html;
                //shadeImageActionContent.innerHTML = html;
                shadeImageWrap.classList.remove('hide');
                detailsElements.forEach(d => {
                    if (d !== this) {
                        d.open = false;
                    }
                });
            }

            if(_areAllDetailsClosed()){
                shadeImageWrap.classList.add('hide');
            }
        });
    });

    function _createModalSwatch(imageUrl,swatch_id,imageSwatchArray) {

        shadeImageWrap.html = '';

        let html = '';

        for (let i = 0; i < imageSwatchArray.length; i++) {
            let modalClass="product-popup-modal__opener quick-add-hidden";
            if(imageSwatchArray.length > 1){
                modalClass="product-popup-modal__opener quick-add-hidden multipleswatch";
            }

            html += '<modal-opener class="'+modalClass+'" data-modal="#PopupModal-' + sectionID + '_' + swatch_id + '_'+i+'">';
            html += '<button id="ProductPopup-' + sectionID + '_' + swatch_id + '_'+i+'" class="product-popup-modal__button" type="button" aria-haspopup="dialog">';
            html += '<span class="popup-image" id="shade_image_popup_action"><img src="' + imageSwatchArray[i] + '" class="popup-icon"></span>';
            if(imageSwatchArray.length === 1){
                html += '<span class="popuptext">' + swatchText + '</span>';
            }

            html += '</button></modal-opener>';

            html += '<modal-dialog id="PopupModal-' + sectionID + '_' + swatch_id + '_'+i+'" class="product-popup-modal popup-palette">';
            html += '<div role="dialog" aria-label="palette-popup" aria-modal="true" class="product-popup-modal__content" tabIndex="-1">';
            html += '<button id="ModalClose-' + sectionID + '_' + swatch_id + '_'+i+'" type="button" class="product-popup-modal__toggle" aria-label="' + closeAlt + '">';
            html += '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-close" fill="none" viewBox="0 0 18 17">';
            html += '<path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor">';
            html += '</svg>';
            html += '</button>';
            html += '<div class="product-popup-modal__content-info" id="shade_image_popup_content"><img src="' + imageSwatchArray[i] + '" class="popup-icon"></div>';
            html += '</div>';
            html += '</modal-dialog>';


        }

        shadeImageWrap.innerHTML = html;


    }

    function _areAllDetailsClosed() {
        const detailsElements = document.querySelectorAll("details");
        return [...detailsElements].every(detail => !detail.open);
    }

    document.querySelectorAll('.js-icon-palette').forEach(function (icon) {
        icon.addEventListener('click', function (event) {

            let shadeID = this.getAttribute("data-variantID");
            let shadeSku = this.getAttribute("data-variantSku");
            let shadeImageUrl = this.getAttribute("data-variantImage");
            let shadePrice = this.getAttribute("data-price");
            let shadeParentItem = this.getAttribute("data-item");
            let shadePosElements = document.querySelectorAll('.js-shade-pos');

            for (let i = 0; i < shadePosElements.length; i++) {
                let pos = shadePosElements[i];
                if (!pos.classList.contains('full')) {
                    let localObj = {};
                    localObj.shadeID = shadeID;
                    localObj.shadeSku = shadeSku;
                    localObj.shadeImageUrl = shadeImageUrl;
                    localObj.shadePrice = shadePrice;
                    localObj.shadeParentItem = shadeParentItem;
                    localObj.i = i;
                    _setShadeHtml(pos, shadeImageUrl, shadeID, shadePrice, shadeSku, shadeParentItem, i);
                    localStorage.setItem('shade-elm-' + sectionID + ' elm-' + (i + 1), JSON.stringify(localObj));
                    updatePrice(sectionID);
                    removeShade();
                    addIconToParent(shadeParentItem, shadeImageUrl, shadeID, i);
                    updatePaletteStatus();
                    break;  // Exit the loop after the first match
                }
            }

        });
    });

    function updatePaletteStatus(){
        let elements = document.querySelectorAll('.js-shade-pos.full');
        let fillElm = elements.length;
        let pdp_palette = document.getElementById('pdp_visoh_palette');
        if(fillElm >= fullPaletteElm){
            pdp_palette.classList.add('fullPaletteSelected');
        }else{
            pdp_palette.classList.remove('fullPaletteSelected');
        }
    }



    function addIconToParent(shadeParentItem, shadeImageUrl, shadeID, i) {
        document.querySelectorAll('.js-icon-wrap').forEach(function (elm) {
            let cParentId = elm.getAttribute('data-item');
            if (shadeParentItem === cParentId) {
                let cShadeId = shadeParentItem + "_" + shadeID + "_" + i;
                let html = '<div class="js-cShade icon_cShade" data-item="' + cShadeId + '" style="background-image: url(' + shadeImageUrl + ')" ></div>';
                elm.innerHTML += html;
            }
        });
    }

    function removeIconToParent(shadeItem) {
        document.querySelectorAll('.js-cShade').forEach(function (elm) {
            let cParentId = elm.getAttribute('data-item');
            if (shadeItem === cParentId) {
                elm.remove();
            }
        });
    }

    function openShadeList() {
        document.querySelectorAll('.js-mobile-add-shade').forEach(function (elm) {
            elm.addEventListener('click', function (event) {
                let choMobile = document.getElementById('choMobile');
                document.body.classList.add('ovh');
                choMobile.classList.add('block');
                setTimeout(() => choMobile.classList.add('open'), 100);
                let choMobileClose = document.getElementById('closeChoMobile');
                choMobileClose.addEventListener('click', function (event) {
                    choMobile.classList.remove('open');
                    document.body.classList.remove('ovh');
                    setTimeout(() => choMobile.classList.remove('block'), 100);
                });

            });
        });
    }


    function getSavedShade() {
        let shadePosElements = document.querySelectorAll('.js-shade-pos');
        for (let i = 0; i < shadePosElements.length; i++) {
            let pos = shadePosElements[i];
            let obj = JSON.parse(localStorage.getItem('shade-elm-' + sectionID + ' elm-' + (i + 1)));
            if (obj) {
                _setShadeHtml(pos, obj.shadeImageUrl, obj.shadeID, obj.shadePrice, obj.shadeSku, obj.shadeParentItem, i);
                addIconToParent(obj.shadeParentItem, obj.shadeImageUrl, obj.shadeID, i);
            }
        }

        updatePrice(sectionID);
        removeShade();
        updatePaletteStatus();
    }

    function _setShadeHtml(pos, shadeImageUrl, shadeID, shadePrice, shadeSku, shadeParentItem, i) {

        let removeIcon = '<div class="close_wrap"><div class="removeShade js-remove-shade" data-index="' + i + '" data-variantID="' + shadeID + '"><svg viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
            '<path d="M2.5 2.5L7.82258 7.82258" stroke="#4F4F4F" style="stroke:#4F4F4F;stroke:color(display-p3 0.3116 0.3116 0.3116);stroke-opacity:1;" stroke-width="0.952381" stroke-linejoin="round"/>\n' +
            '<path d="M2.5 7.82275L7.82258 2.50017" stroke="#4F4F4F" style="stroke:#4F4F4F;stroke:color(display-p3 0.3116 0.3116 0.3116);stroke-opacity:1;" stroke-width="0.952381" stroke-linejoin="round"/>\n' +
            '</svg></div></div> ';

        pos.style.backgroundImage = 'url(' + shadeImageUrl + ')';
        pos.style.backgroundSize = 'cover';  // Optional: Ensures the image covers the entire div
        pos.style.backgroundPosition = 'center';
        pos.innerHTML += removeIcon;
        pos.classList.add('full');
        pos.classList.add('js-price');
        pos.classList.add('js-palette-to-cart');
        pos.setAttribute('data-shade-id', shadeID);
        pos.setAttribute('data-price', shadePrice);
        pos.setAttribute('data-sku', shadeSku);
        pos.setAttribute('data-sku', shadeSku);
        pos.setAttribute('data-item', shadeParentItem);

    }

    function updatePrice(sectionID) {
        let totalPrice = 0;
        document.querySelectorAll('.js-price').forEach(function (item) {
            let price = parseInt(item.getAttribute("data-price"));
            totalPrice = totalPrice + price;
        });

        localStorage.setItem('palette-' + sectionID + '-price', totalPrice);

        let PalettePriceDiv = document.getElementById('renderPricePalette');
        PalettePriceDiv.innerHTML = "€" + Visoh.formatMoney(totalPrice, '{{amount_with_comma_separator}}');
    }

    function removeShade() {
        document.querySelectorAll('.js-remove-shade').forEach(function (item) {
            item.addEventListener('click', function (event) {

                let shadeID = this.getAttribute("data-variantID");
                let index = this.getAttribute("data-index");
                let shadePosElements = document.querySelectorAll('.js-shade-pos');
                let pos = shadePosElements[index];
                if (pos.getAttribute("data-shade-id") === shadeID) {
                    let iconId = pos.getAttribute("data-item") + '_' + pos.getAttribute("data-shade-id") + '_' + index;
                    removeIconToParent(iconId);
                    pos.removeAttribute('data-shade-id');
                    pos.removeAttribute('data-price');
                    pos.removeAttribute('data-sku');
                    pos.removeAttribute('data-item');
                    pos.style.backgroundImage = 'initial';
                    pos.classList.remove('full');
                    pos.classList.remove('js-price');
                    pos.classList.remove('js-palette-to-cart');
                    let close = pos.querySelector('.close_wrap');
                    close.remove();
                    localStorage.removeItem('shade-elm-' + sectionID + ' elm-' + (parseInt(index) + 1));
                    updatePrice(sectionID);
                    updatePaletteStatus();
                }
            });
        });
    }



    function addPaletteToCart() {
        const addToCartDesktop = document.getElementById('jsAddToCartDesktop');
        const addToCartMobile = document.getElementById('jsAddToCartMobile');

        if (addToCartDesktop) {
            addToCartDesktop.addEventListener('click', function (event) {
                let obj = _createAttribute();
                Visoh.addToCart('.js-palette-to-cart','data-shade-id',obj)
            });
        }

        if (addToCartMobile) {
            addToCartMobile.addEventListener('click', function (event) {
                let obj = _createAttribute();
                Visoh.addToCart('.js-palette-to-cart','data-shade-id',obj)
            });
        }
    }

    function _createAttribute(){
        const custumAttribute = document.getElementById('jsPaletteDetail').value;
        let obj = {};
        obj['Id'] = new Date().getTime();
        if(custumAttribute){
            obj['Incisione'] = custumAttribute;
        }
        return obj;
    }

    function observerIncisione(){
        const inputElement = document.getElementById('jsPaletteDetail');
        const paletteItem = document.getElementById('pdp_visoh_palette');
        let idProduct = paletteItem.getAttribute("data-shade-id");
        if(localStorage.getItem('incisione-' + idProduct + '-palette')){
            inputElement.value = localStorage.getItem('incisione-' + idProduct + '-palette');
        }

        inputElement.addEventListener('input', (event) => {
            localStorage.setItem('incisione-' + idProduct + '-palette', event.target.value);
        });
    }

    observerIncisione();
    getSavedShade();
    addPaletteToCart();
    openShadeList();
});
